<template>
  <div class="progress">
    <div class="progress__scale" :style="{ width: `${percent}%` }">
      <div class="progress__percent">
        {{ percent }}%
      </div>
    </div>
    <div v-if="links" class="progress__links">
      <router-link
        v-for="(item, i) in links"
        :key="`link_${i}`"
        :to="item.path"
        class="progress__link"
      />
    </div>
  </div>
</template>

<script>
import { slides } from '@/router/index';

export default {
  name: 'BaseProgress',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    links() {
      if (this.count === 0) return null;
      return new Array(this.count).fill(1).map((_, i) => slides[i]);
    },
  },
};
</script>

<style lang="stylus">
.progress
  position relative
  display block
  width 100%
  height 6px
  background-color #DEE6FF
  border-radius @height
  &__scale
    position relative
    display block
    width auto
    height inherit
    border-radius inherit
    color $c_bright
    background-color currentColor
    transition width 1400ms cubic-bezier(0.76, 0, 0.24, 1)
  &__percent
    abs bottom 100% right
    font-size 0.7em
    padding 0.25em 0
  &__links
    abs top bottom left right
    display flex
    margin -1em 0
  &__link
    display flex
    align-items center
    flex-grow 1
    flex-basis 0
    height 100%
    &._active_exact
      pointer-events none
    +landscape()
      &:before
        content ''
        display block
        width 100%
        height 6px
        background-color alpha(#000, 15%)
        border solid #fff
        border-width 0 1px
        opacity 0
      &:hover
        &:before
          opacity 1
      &:first-child
        &:before
          border-radius 3px 0 0 3px
          border-left-color transparent
      &:last-child
        &:before
          border-radius 0 3px 3px 0
          border-right-color transparent
</style>
